export default __webpack_public_path__ + "static/media/font_assets.5d186dcd.png";